import type { TableColumnsType } from "antd";
import { IDetailsItems } from "store/readers-tags/readers/readers-model";
import useTranslation from "utils/hooks/useTranslation";

const ExpandedColumns = (): TableColumnsType<IDetailsItems> => {
  const READER = useTranslation({ id: "reader" });
  const ANTENNA_NUMBER = useTranslation({ id: "antenna_number" });
  const ANTENNA = useTranslation({ id: "antenna" });
  const SECTOR = useTranslation({ id: "sector" });
  const FLOW = useTranslation({ id: "flow" });
  const PORT = useTranslation({ id: "port" });

  return [
    { title: READER, width: "20%", dataIndex: "readerLabel", key: "readerLabel", render: (readerLabel: string) => readerLabel || "--" },
    { title: ANTENNA_NUMBER, width: "10%", dataIndex: "antennaNumber", key: "antennaNumber", render: (antennaNumber: string) => antennaNumber || "--" },
    {
      title: ANTENNA,
      width: "20%",
      dataIndex: "antennaDescription",
      key: "antennaDescription",
      render: (antennaDescription: string) => antennaDescription || "--",
    },
    { title: SECTOR, width: "20%", dataIndex: "sector", key: "sector", render: (sector: string) => sector || "--" },
    {
      title: FLOW,
      width: "20%",
      dataIndex: "flow",
      key: "flow",
      render: (flow: string) => flow || "--",
    },
    {
      title: PORT,
      width: "10%",
      dataIndex: "antennaPort",
      key: "antennaPort",
      render: (antennaPort: string) => antennaPort || "--",
    },
  ];
};

export default ExpandedColumns;
